import React from "react";
import parse from "html-react-parser";
import cookieBannerHtml from "../SingleSiteNav/cookieBanner.html";

const CookieBanner = ({ children }) => {
  return parse(cookieBannerHtml);
};

export default CookieBanner;
